import React from 'react';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function Experience() {
    return <Paper elevation={3} className='section-container' id='experience'>
        <h2>Experience</h2>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-ip-content"
                id="panel-ip-header"
            >
                <Typography><b>Imagine Pediatrics</b>&nbsp;&nbsp;&nbsp;<i>(<b>Senior Software Engineer</b>, September 2025 - Present)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Working on a team to help improve pediatric care for kiddos with greater needs in the home and more!</Typography>
                <ul>
                    <li>Worked on a team to integrate FRND phone results to respect DNC phone numbers, reducing unwanted calls and improving patient experience.</li>
                    <li>Always working to improve the way a provider can view patient information to provide better care through better UI/UX and data accessibility.</li>
                    <li>A portion of my time is spent on Platform Engineering initiatives to improve developer experience and infrastructure.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-aws-content"
                id="panel-babyscripts-header"
            >
                <Typography><b>Babyscripts</b>&nbsp;&nbsp;&nbsp;<i>(<b>Tech Lead</b>, Dec 2022 - July 2025)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Led and collaborated with engineers to develop technology for maternal safety.</Typography>
                <ul>
                    <li>Ran daily stand-ups for the engineering team.</li>
                    <li>Leveraged AI/LLM for code generation (Co-Pilot, Chat-GPT 40) and local models (ollama-cli) to accelerate development.</li>
                    <li>Migrated key data from DynamoDB to PostgreSQL with TypeScript APIs, improving referential integrity and patient care.</li>
                    <li>Developed new management UIs using React Micro-Frontends.</li>
                    <li>Implemented multi-language support across the platform and app using Lokalise, Flutter, PostgreSQL, and TypeScript API/GraphQL.</li>
                    <li>Led a team to create a new Flutter app with a Serverless TypeScript RESTful API.</li>
                    <li>Completed a TypeScript/Angular project leveraging DynamoDB and a Serverless API for health assessments to detect postpartum depression and direct patients to resources.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-bibliu-content"
                id="panel-bibliu-header"
            >
                <Typography><b>BibliU</b>&nbsp;&nbsp;&nbsp;<i>(<b>Senior Software Engineer</b>, 2019 - Dec 2022)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Improved student experience with e-textbook technologies and worked on data pipelines.</Typography>
                <ul>
                    <li>Worked on the Universal Learning team, integrating universities and solving tech challenges using an AWS/S3 -&gt; Stitch -&gt; Snowflake -&gt; DBT -&gt; Retool/PopSQL data pipeline.</li>
                    <li>Utilized Mob Programming to enhance code quality and review times.</li>
                    <li>Maintained focus on the student team, delivering app improvements, including full book TTS, color blindness enhancements, speed improvements, and a UI/A11y overhaul with Lit Element.</li>
                    <li>Projects were primarily in TypeScript and hosted on AWS with EKS or Elastic Beanstalk. We utilized RDS for PostgreSQL and also used DynamoDB.</li>
                    <li>Gained expertise in project management, cross-world communication, AWS, TypeScript, and modern data pipelining. Explored React and front-end data management.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-wwda-content"
                id="panel-wwda-header"
            >
                <Typography><b>Tex Visions</b>&nbsp;&nbsp;&nbsp;<i>(<b>Senior Software Developer</b>, 2014 - Oct 2019)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Resolved legacy bugs and led development of new E-Commerce features.</Typography>
                <ul>
                    <li>Mentored junior developers and conducted code reviews.</li>
                    <li>Introduced daily stand-ups and Waffle.io for bug tracking.</li>
                    <li>Engineered a Product Feed System in C# and .NET Core, generating pricing data for shopping aggregators, interfacing with CSCart and Microsoft Dynamics AX.</li>
                    <li>Developed a textile printing design tool using HTML5 Canvas and JavaScript, with a C#/.NET Core backend on Linux using SVG for data.</li>
                    <li>Contributed significant bug fixes to the E-Commerce site in PHP, JavaScript, and HTML.</li>
                    <li>Created a multi-process NodeJS database abstraction service with Sequelize ORM for MySQL databases, including an auto-discovering controller system with JSON schema validation.</li>
                    <li>Wrote the framework and much of the company intranet using NodeJS and Backbone.js, used for help desk to accounting reports.</li>
                    <li>Leveraged the intranet to create a production automation system for scheduling jobs and tracking tasks.</li>
                    <li>Deployed a C#/.NET Core Linux service for box packing and shipping, abstracting UPS/FedEx communications for rates and address validations.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-wwda-content"
                id="panel-wwda-header"
            >
                <Typography><b>VS Networks</b>&nbsp;&nbsp;&nbsp;<i>(<b>Software Engineer</b>, 2011 - 2014)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Contributed across the full stack, including Linux systems programming, MySQL database development, and front-end JavaScript.</Typography>
                <ul>
                    <li>Supported a digital advertising platform with a web-based content scheduling system.</li>
                    <li>Enhanced the web interface for managing client organization, media scheduling, and uploads using modern JavaScript libraries.</li>
                    <li>Developed C++/Qt software to distribute touch-based catalogs to Windows and an initial Android version using Java and HTML/JavaScript.</li>
                    <li>Wrote C++/Qt software to display dynamic HTML/JavaScript ads with real-time information.</li>
                    <li>Designed a Python/PostgreSQL system to process ad play and touch catalog click logs into a statistics database with APIs for reporting.</li>
                    <li>Designed a Python/PostgreSQL reporting system on Linux VMs to aggregate data from various sources for business and media system insights.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-wwda-content"
                id="panel-wwda-header"
            >
                <Typography><b>Bed Bath &amp; Beyond</b>&nbsp;&nbsp;&nbsp;<i>(<b>Programmer / Analyst</b>, 2010 - 2011)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Collaborated on data-driven automation for warehouse operations using HTML, JavaScript, IBM DB2, MySQL, Python, and C++.</Typography>
                <ul>
                    <li>Optimized e-commerce workflows with statistical analysis.</li>
                    <li>Developed a web interface (HTML/JavaScript/AJAX on Windows, Apache, MySQL, Python) to diagnose shipping box issues from multiple systems.</li>
                    <li>Analyzed customer purchase records (IBM DB2) to optimize shipping facility locations, outputting Google Maps heatmaps and reports.</li>
                    <li>Wrote a Python, HTML, and JavaScript web interface and reporting backend on Apache to automate aging reports, reducing completion time from days to minutes.</li>
                    <li>It read data from IBM DB2 and proprietary APIs.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-wwda-content"
                id="panel-wwda-header"
            >
                <Typography><b>Adept Results</b>&nbsp;&nbsp;&nbsp;<i>(<b>Programmer</b>, 2007 - 2010)</i></Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography>Worked on rapid development of E-Commerce websites with fast analysis of conversion rates and usage patterns.</Typography>
                <ul>
                    <li>Managed nightly PCI Compliant credit-card processing systems using MySQL and Perl on Debian Linux.</li>
                    <li>Created a web-frontend (Perl backend, HTML/JavaScript/AJAX) for live conversion rate display, refreshing minutely, enabling rapid design decisions.</li>
                    <li>Helped develop a Perl-based content management system for easy e-commerce site development, deployment, and A-B testing with templatization.</li>
                </ul>
            </AccordionDetails>
        </Accordion>
    </Paper>;
}
